export default __webpack_public_path__ + "static/media/Icon-Linkedin1.8152f936.svg";